var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77764 15.9941C3.33912 16.187 3.11987 16.2835 2.98532 16.2411C2.86868 16.2044 2.77727 16.1131 2.74041 15.9965C2.69788 15.862 2.79409 15.6426 2.98652 15.2039L8.44755 2.75277C8.62125 2.35671 8.70811 2.15869 8.82953 2.09807C8.93499 2.04543 9.05905 2.04543 9.1645 2.09807C9.28593 2.15869 9.37278 2.35671 9.54649 2.75277L15.0075 15.2039C15.1999 15.6426 15.2962 15.862 15.2536 15.9965C15.2168 16.1131 15.1254 16.2044 15.0087 16.2411C14.8742 16.2835 14.6549 16.187 14.2164 15.9941L9.23866 13.8039C9.14965 13.7647 9.10514 13.7451 9.05891 13.7374C9.01793 13.7305 8.9761 13.7305 8.93513 13.7374C8.8889 13.7451 8.84439 13.7647 8.75538 13.8039L3.77764 15.9941Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.ee5d804c28f6f3b6fac299b4e2054244.svg";
export { ForwardRef as ReactComponent };